import { getClient } from "src/api/api.ts";
import { HttpError } from "src/api/httpError.ts";
import { ShippingLine } from "src/model/shippingLine.ts";

export const fetchShippingLines = async (): Promise<ShippingLine[]> => {
  const {
    data,
    error,
    response: { status },
  } = await getClient().GET("/API/iSEA5/V2.1/ShippingLines");

  if (error !== undefined) {
    if (error.loggingMessage) {
      throw new HttpError(status, error.loggingMessage);
    }
    throw new HttpError(status, error.message);
  }

  if (data !== undefined) {
    return data;
  }

  throw new Error("Failed to fetch shippinglines");
};
